// Copyright (c) Docugami, Inc. All rights reserved.

import { TokenRange } from "networking/api";

export class TokenRangeUtils {
     /**
     * Is the candidate tokenRange inside of the current tokenRange (or the same)
     */
    static rangeIsContained(candidate: TokenRange, current: TokenRange): boolean {
        return candidate.fromTok >= current.fromTok && candidate.toTok <= current.toTok;
    }

    /**
     * Are the two ranges for the same thing
     */
    static rangesEqual(a: TokenRange, b: TokenRange): boolean {
        return a.fromTok === b.fromTok && a.toTok === b.toTok;
    }

    /**
     * Do these ranges share any tokens?
     */
    static rangesOverlap(a: TokenRange, b: TokenRange): boolean {
        return Math.max(a.fromTok, b.fromTok) < Math.min(a.toTok, b.toTok);
    }

    static readingOrderComparer(a?: TokenRange, b?: TokenRange): number {
        if (!a && !b)
        {
            return 0;
        }
        else if (!a)
        {
            return -1;
        }
        else if (!b)
        {
            return 1;
        }

        let order = a.fromTok - b.fromTok;
        if (order === 0) {
            order = b.toTok - a.toTok;
        }

        return order;
    }

    static rangeIsEmpty(tokenRange: TokenRange): boolean {
        return tokenRange.fromTok === tokenRange.toTok;
    }

    static contains(tokenRange: TokenRange, token: number): boolean {
        return token >= tokenRange.fromTok && token < tokenRange.toTok;
    }

    static getLength(tokenRange: TokenRange): number {
        return tokenRange.toTok - tokenRange.fromTok;
    }
}
